import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "promotion-image-container" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "promotion-date" }
const _hoisted_4 = { class: "promotion-content" }
const _hoisted_5 = { class: "promotion-title" }
const _hoisted_6 = { class: "promotion-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "promotion-card",
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.handleToDetail($props.promotion)), ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: $props.promotion.coverPic,
        alt: $props.promotion.title,
        class: "promotion-image",
        onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleImageError && $setup.handleImageError(...args)))
      }, null, 40, _hoisted_2),
      _createElementVNode("div", _hoisted_3, _toDisplayString($setup.formatDate($props.promotion.createdTime)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h3", _hoisted_5, _toDisplayString($props.promotion.title), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString($props.promotion.description), 1),
      ($props.promotion.link)
        ? (_openBlock(), _createBlock(_component_van_button, {
            key: 0,
            type: "primary",
            size: "small",
            class: "promotion-button"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" 了解更多 ", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}